module.exports = __webpack_public_path__ + "img/orangeV.2074fdde.png";